module.exports = "<div class=\"layout__item u-pl0 u-mb0\">\n    <div *ngFor=\"let image of images\" class=\"layout__item u-1/3\">\n        <div *ngIf=\"image.textBold\" style=\"font-size: 1.4rem; color: #828282;\">{{ image.textBold }}</div>\n        <img *ngIf=\"image.url\" [src]=\"image.url\" style=\"border-radius: 10px; max-height: 80px; width: 50%;\">\n        <div *ngIf=\"image.text\" class=\"u-pt-\" style=\"font-weight: 300; color: #828282; font-size: 0.8rem; line-height: 13px;\">{{ image.text }}</div>\n    </div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/explore/widgets/imagesRowExploreWidgetNg2.html
 ** module id = 902
 ** module chunks = 0
 **/